/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CollectionPackagingUnitUpdateRequest } from '../../models/collection-packaging-unit-update-request';
import { CollectionPackagingUnitUpdateResponse } from '../../models/collection-packaging-unit-update-response';

export interface UpdateCollectionPackagingUnit$Params {

/**
 * UUID of the parent product (PackagingUnit)
 */
  packagingUnitId: string;

/**
 * UUID of the child collection packaging unit to update
 */
  collectionPackagingUnitId: string;
      body: CollectionPackagingUnitUpdateRequest
}

export function updateCollectionPackagingUnit(http: HttpClient, rootUrl: string, params: UpdateCollectionPackagingUnit$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectionPackagingUnitUpdateResponse>> {
  const rb = new RequestBuilder(rootUrl, updateCollectionPackagingUnit.PATH, 'put');
  if (params) {
    rb.path('packagingUnitId', params.packagingUnitId, {});
    rb.path('collectionPackagingUnitId', params.collectionPackagingUnitId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CollectionPackagingUnitUpdateResponse>;
    })
  );
}

updateCollectionPackagingUnit.PATH = '/products/{packagingUnitId}/collections/{collectionPackagingUnitId}';
